const points = [
  {
    title: 'We track the shift',
    body: 'New models, tools, agent patterns, and IDE capabilities appear constantly. Compound watches that surface and folds what actually works into the skill system — so your team does not rebuild method every quarter.',
  },
  {
    title: 'Skills stay current',
    body: 'Packs are rewritten and optimized as the industry moves. You inherit the update path through subscription — not a frozen prompt archive that aged out last spring.',
  },
  {
    title: 'Search lean, spend lean',
    body: 'Skills are built for fast, precise lookup — graph, RAG, and semantic first — so agents find the right ground without burning tokens on blind exploration.',
  },
]

/**
 * Industry-currency plate — magenta attention rules (same grammar as caution),
 * positive thesis: the AI landscape moves; Compound moves with it.
 */
export function CompoundIndustry() {
  return (
    <section id="industry" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="border-2 border-overprint">
          <div className="border-b-2 border-overprint px-5 py-4 sm:px-7">
            <p className="cell-label mb-2 text-overprint">Why the method stays sharp</p>
            <h2 className="section-title text-ink">
              The AI landscape moves. Compound moves with it.
            </h2>
          </div>

          <div className="border-b border-overprint/40 px-5 py-5 sm:px-7">
            <p className="max-w-3xl text-base leading-relaxed text-ink-muted">
              Models, tools, approaches, and agent workflows change month to
              month. We track what is real, apply it inside Compound skills, and
              keep those skills tuned for optimal search and low token waste —
              so your delivery follows industry practice instead of last year&apos;s
              defaults.
            </p>
          </div>

          <div className="grid divide-y divide-overprint/40 lg:grid-cols-3 lg:divide-x lg:divide-y-0">
            {points.map((point) => (
              <article key={point.title} className="px-5 py-6 sm:px-7 lg:py-7">
                <h3 className="entry-title text-ink">{point.title}</h3>
                <p className="mt-3 text-[0.9375rem] leading-relaxed text-ink-muted">
                  {point.body}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
